import { LoadableApp } from 'ui-seeker/core'
import { ADMIN_CITIES, ADMIN_SCHEDULERS, ADMIN_USERS } from 'app/config'

const Cities = LoadableApp(import('./Cities'))
const Schedulers = LoadableApp(import('./Schedulers'))
const Users = LoadableApp(import('./Users'))

const PageRoutes = [
    { path: ADMIN_CITIES.path, component: Cities, needLogin: true, header: false },
    { path: ADMIN_SCHEDULERS.path, component: Schedulers, needLogin: true, header: false },
    { path: ADMIN_USERS.path, component: Users, needLogin: true, header: false },
]

export default PageRoutes